import { Inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    lpTag: any;
  }
}

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class LiveChatAgentSupportService {
  constructor(@Inject('Window') private windowRef = window, private authService: AuthService) {}

  isLiveChatAvailable(liveChatTagId: string): boolean {
    let isLiveChatAvailable = false;
    if (this.windowRef.lpTag?.events?.hasFired) {
      const lpTagOffersImpressions = this.windowRef.lpTag.events.hasFired('OFFER_IMPRESSION');
      const engagementId = lpTagOffersImpressions[0]?.data?.engagementId;
      if (engagementId) {
        const engagementStatus = this.windowRef.lpTag.taglets?.rendererStub?.getEngagementState(engagementId);
        if (engagementStatus?.state === 1 && this.isTagLoadedOnPage(liveChatTagId)) {
          isLiveChatAvailable = true;
        }
      }
    }
    return isLiveChatAvailable;
  }

  // this function is for live chat tiles which are not displayed on page load and are show dynamically later which could be behind a CTA button on the page.
  // in this scenario you need to call the following function to reload live person monitor to look for the live person div id to integrate chat.
  reloadLiveAgentMonitor() {
    this.windowRef?.lpTag?.newPage(window.location.href);
  }

  // this function setups the live person tag to use authenticated chat.
  // as part of this we need to provide idToken which is then used by Live person to pass customer details to live person.
  setupAuthChat() {
    if (!this.windowRef.lpTag || !this.authService.isAuthenticated) {
      return;
    }
    // this.windowRef.lpTag.identities = [];
    /* eslint-disable-next-line  @typescript-eslint/dot-notation */
    this.windowRef['lpGetAuthenticationToken'] = (callback) => {
      // On Success
      // LP asked for id_token or auth code in Code Flow
      callback(this.authService.idToken);
      // On Failure
      callback('', 'error');
    };

    const identityFn = (callback) => {
      // LP asked for identify
      callback({
        iss: this.authService.getIdentityClaimProperty('iss'),
        acr: 'loa1',
        sub: this.authService.getIdentityClaimProperty('sub'),
      });
    };

    this.windowRef.lpTag.identities = [identityFn];
  }

  private isTagLoadedOnPage(liveChatTagId: string) {
    return document.getElementById(liveChatTagId)?.getElementsByTagName('a').length > 0;
  }
}
